import config from 'config/config';
import { onRequest, RequestMethod } from "common/axios/axios"
import { getApiUrl } from "common/axios/getApiUrl"
import { getDeviceId } from "common/utils/deviceId"

// SSO 서비스 ID (DOKOCREW 앱)
const SERVICE_ID = config.SERVICE_ID;

export class UserRepository {
    // WIZ-SSO API
    static onSsoLogin = (params: { email: string; password: string; deviceId?: string; os?: string }) => {
        return onRequest({
            url: getApiUrl('ssoLogin'),
            method: RequestMethod.POST,
            params: {
                serviceId: SERVICE_ID,
                userId: params.email,
                password: params.password,
                deviceId: params.deviceId || getDeviceId(),
                os: params.os || 'web'
            }
        })
    }

    static onSsoSocialLogin = (params: { provider: string; providerUserId: string; providerAccessToken: string; deviceId?: string; os?: string }) => {
        return onRequest({
            url: getApiUrl('ssoSocialLogin'),
            method: RequestMethod.POST,
            params: {
                serviceId: SERVICE_ID,
                provider: params.provider,
                providerUserId: params.providerUserId,
                providerAccessToken: params.providerAccessToken,
                deviceId: params.deviceId || getDeviceId(),
                os: params.os || 'web'
            }
        })
    }

    static onSsoSignup = (params: { email: string; password: string; nickname: string; deviceId?: string; os?: string }) => {
        return onRequest({
            url: getApiUrl('ssoSignup'),
            method: RequestMethod.POST,
            params: {
                serviceId: SERVICE_ID,
                snsLogin: false,
                email: params.email,
                password: params.password,
                nickname: params.nickname,
                deviceId: params.deviceId || getDeviceId(),
                os: params.os || 'web'
            }
        })
    }

    static onSsoRefresh = (refreshToken: string) => {
        return onRequest({
            url: getApiUrl('ssoRefresh'),
            method: RequestMethod.POST,
            params: { refreshToken }
        })
    }

    static onSsoLogout = (accessToken: string, provider?: string) => {
        return onRequest({
            url: getApiUrl('ssoRevoke'),
            method: RequestMethod.POST,
            params: { accessToken, provider: provider || 'EMAIL' }
        })
    }

    // SSO 회원정보 조회
    // 주의: userId(암호화) 를 query 로 반드시 같이 전송해야 SSO 가 해당 유저를
    // 정확히 식별함. 누락 시 Mock 모드 서버의 기본 분기에 걸려 엉뚱한 유저 반환됨.
    static onGetSsoUser = (accessToken: string, userId?: string) => {
        return onRequest({
            url: getApiUrl('ssoUser'),
            method: RequestMethod.GET,
            headers: {
                'Authorization': `Bearer ${accessToken}`
            },
            query: userId ? { userId } : undefined,
        })
    }

    // SSO 프로필 이미지 업로드
    static onUploadProfileImage = (file: File) => {
        const formData = new FormData();
        formData.append('file', file);
        return onRequest({
            url: getApiUrl('ssoProfileImage'),
            method: RequestMethod.POST,
            params: formData,
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    }

    // SSO 프로필 이미지 삭제
    static onDeleteProfileImage = () => {
        return onRequest({
            url: getApiUrl('ssoProfileImage'),
            method: RequestMethod.DELETE,
        })
    }

    // SSO 닉네임 변경
    static onUpdateNickname = (nickname: string) => {
        return onRequest({
            url: getApiUrl('ssoProfileNickname'),
            method: RequestMethod.PUT,
            params: { nickname }
        })
    }

    // SSO 상태 메시지 변경 (null이면 삭제)
    static onUpdateStatusMsg = (statusMessage: string | null) => {
        return onRequest({
            url: getApiUrl('ssoProfileStatusMsg'),
            method: RequestMethod.PUT,
            params: { statusMessage }
        })
    }

    // SSO 프로필 전체 저장 (닉네임 + 상태메시지)
    static onUpdateProfile = async (params: { nickName?: string; statusMessage?: string }) => {
        const results: any[] = [];
        if (params.nickName) {
            results.push(await UserRepository.onUpdateNickname(params.nickName));
        }
        if (params.statusMessage !== undefined) {
            results.push(await UserRepository.onUpdateStatusMsg(params.statusMessage || null));
        }
        return results[0] || { status: 200 };
    }

    // SSO 회원탈퇴
    static onWithdraw = () => {
        return onRequest({
            url: getApiUrl('ssoWithdraw'),
            method: RequestMethod.DELETE,
        })
    }
}